export const CONTACT_TYPE = {
  COMPANY_WITH_CONTACT: "company_with_main_contact",
  COMPANY_WITHOUT_CONTACT: "company",
  SINGLE: "single",
};
export const FORM_DATA_KEYS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
} as const;
export const FORM_FIELD = {
  DATE_FIELD: "date",
  INPUT_FIELD: "text",
  PHONE_FIELD: "phone",
  SELECT_FIELD: "select",
};
export const MEMBER_LISTING = {
  ACTIVE_CLUB_MEMBER: 1,
  EMPTY_MEMBER_DATA: 0,
};
export const SUBHEADING_FIELD = {
  COUNTRY: "country",
  EMAIL: "email",
  LANGUAGE: "language",
};

export const USER_FORM_FIELD = {
  CONTACT_TYPE: "contactType",
  EMAIL: "email",
  ZIPCODE: "zipcode",
};
